import { onMounted, onUnmounted } from 'vue'

export function usePopState (hook: unknown) {
  onMounted(() => {
    window.addEventListener('popstate', hook)
  })

  onUnmounted(() => {
    window.removeEventListener('popstate', hook)
  })
}
